import event from '~helpers/mixpanel';

const routerPageTexts = {
  properties: 'Properties',
  property: 'Properties',
  withdrawal: 'Payouts',
  payment: 'Payment',
  reconciliation: 'Bookings',
  'booking/list': 'Bookings',
  bookings: 'Bookings',
  board: 'Board',
  account: 'Account',
};

export const getCurrentPage = () => {
  const { pathname } = window.location;
  const routerTextKey = Object.keys(routerPageTexts).find(item => pathname.includes(`/${item}`));

  return routerPageTexts[routerTextKey];
};

export const sendViewedLiveChatIconTrack = () => {
  const unread = Number(document?.querySelector('.live-chat__unread-count')?.innerText);

  event('Viewed LiveChat Icon', {
    Unread: unread,
  });
};

export const sendClickedLiveChatIconTrack = () => {
  const unread = !!Number(document?.querySelector('.live-chat__unread-count')?.innerText);

  const currentPage = getCurrentPage();
  event('Clicked LiveChat Icon', {
    Unread: unread,
    'Current Page': currentPage,
  });
};

export const sendClickedOnBookingDetailsPageTrack = () => {
  const chatInfo = window?.hurricane?.chatInfo ?? {};
  event('Clicked on Booking Details page', {
    'Click Position': 'Message',
    'Property Name': chatInfo?.propertyName,
    'Property Id': chatInfo?.propertyId,
    'Property Slug': chatInfo?.propertySlug,
    'Booking Status': chatInfo?.bookingStatus,
    'Booking Journey': chatInfo?.bookingJourney,
  });
};

export default sendClickedLiveChatIconTrack;
